// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".title-list--CLS-block[data-v-4ec30af6]{min-height:100vh}", ""]);
// Exports
module.exports = exports;
